import { useContext, useEffect, useRef, useState } from 'react';
import './productsList.scss';
import { Product } from '../../types/types_product';
import { Product_2 } from '../../types/types_product_2';
import { ProductsDataContext } from '../../pages/Home/Home';
import ProductsListLink from './ProductsListLink/ProductsListLink';
import ProductsListLink2 from './ProductsListLink_2/ProductsListLink2';
import { useAutoScroll } from '../../hooks/useAutoScroll';
import Logo from '../Logo/Logo';
import { ym } from "../../shared/ym/ym";

const SCROLL_SPEED = 1;
const IDLE_TIME = 1000;

interface ProductsListProp {
   store_url?: string;
}

function ProductsList({ store_url = "https://www.ozon.ru/" }: ProductsListProp) {
   const [items, setItems] = useState<(Product | Product_2)[]>([]);
   const containerRef = useRef<HTMLDivElement | null>(null);
   useAutoScroll(containerRef, { speed: SCROLL_SPEED, idleTime: IDLE_TIME });

   const context = useContext(ProductsDataContext);
   if (!context) throw new Error('PromoDataContext is not provided');
   const { productsData } = context;
   const handleClick = () => {
      ym(process.env.REACT_APP_YOUR_COUNTER_ID, "reachGoal", "button_click");
   };


   useEffect(() => {
      if (!productsData || productsData.length === 0) return;
      setItems([...productsData, ...productsData]);
   }, [productsData]);

   const OZON_PRODUCT_URL = 'https://www.ozon.ru/product/';

   return (
      <div
         className="productsList-wrapper"
         style={{ overflow: 'hidden', maxHeight: '100%' }}
      >
         <div className="productsList" ref={containerRef} tabIndex={0}>
            <div className="productsList__img-container productsList__img-container-first"></div>
            {items.length >= 1 &&
               <div className="productsList__img-container productsList__logo-container">
                  <a
                     href={`${store_url}`}
                     target="_blank"
                     rel="noopener noreferrer"
                     onClick={handleClick}>
                     <Logo />
                  </a>
               </div>
            }
            {items.length >= 1 && items.map((item, index) => (
               <div className="productsList__img-container" key={`a-${index}`}>
                  {'product_id' in item ? (
                     <ProductsListLink item={item} url={OZON_PRODUCT_URL} />
                  ) : (
                     <ProductsListLink2 item={item} url={OZON_PRODUCT_URL} />
                  )}
               </div>
            ))}
         </div>

         {items.length < 1 &&
            <div className="productsList__loading">Загрузка...</div>
         }
      </div >
   );
}

export default ProductsList;
